﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_contact from './tpl/contact.html';
import language from '../../../common/language';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_DialogWaiting from '../../../lib/views/dialogWaiting/dialogWaiting';
import View_DialogBox from '../../../lib/views/dialogBox/dialogBox';
import * as Entities_PublicRecaptchaContact from '../../entities/publicRecaptchaContact';  
import config from '../../../common/config';

export default View_LayoutError.extend({
    getTemplate: function () {
        return tpl_contact({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        this.model.attributes.Name = '';
        this.model.attributes.EmailFrom = '';
        this.model.attributes.Phone = '';
        this.model.attributes.Subject = '';
        this.model.attributes.Body = '';

        this.listenTo(this.model, 'change', this.render, this);
    },
    onBeforeShow: function () {
    },
    ui: {
        'contact_inputName' : '#contact_inputName',
        'contact_inputEmailFrom' : '#contact_inputEmailFrom',
        'contact_inputPhone' : '#contact_inputPhone',
        'contact_inputSubject' : '#contact_inputSubject',
        'contact_textareaBody' : '#contact_textareaBody',
        'contact_btnSubmit' : '#contact_btnSubmit',
        'contact_p_verifyOK' : '#contact_p_verifyOK',
        'recaptcha_container' : '#recaptcha_container'
    },
    events: {
        'click #contact_btnSubmit': 'btnSubmitClick',
    },
    onRender: function () {
    },
    onAttach(){
    },
    clearView : function() {
        /*this.ui.contact_inputName.val('');
        this.ui.contact_inputEmailFrom.val('');
        this.ui.contact_inputPhone.val('');
        this.ui.contact_inputSubject.val('');
        this.ui.contact_textareaBody.val();*/

        this.app.router.contact();
    },
    loadCaptcha: function() {
        var self = this;

        var getRecaptchaResponse = function(response) {
            //self.btnSubmitClick(null);

            var data = {
                response: response
            }

            //var recaptchaModel = new Entities_PublicRecaptchaContact.Model();
            //recaptchaModel.attributes.response = response;
            //recaptchaModel.attributes.Id = -1;

            self.model.attributes.response = response;

            self.model.save(self.model.attributes, {
                route : 'contact',
                silent: true,
                wait:true,
                //dataType: 'text',
                success: function success() {
                    var dialogBoxModel = new Entities_Empty.Model();
                    dialogBoxModel.attributes.Title = resources.X100662;
                    dialogBoxModel.attributes.Text = resources.X100657;
                    dialogBoxModel.attributes.Button = resources.X100279;

                    var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: self });
                    var callback2 = function () {
                        self.stopListening(dialogBox, "dialog:okclicked", callback2);

                        self.clearView();
                    }
                    self.listenTo(dialogBox, "dialog:okclicked", callback2);
                    self.app.dialogRegion.show(dialogBox);
                },
                error: function error() {
                    alert("Error");
                }
            });
        };

        var renderCaptcha = function() {
            self.captchaWidgetId = grecaptcha.render('recaptcha_container', {
                sitekey : config.googleRecaptchaSiteKey(),
                callback: getRecaptchaResponse,
                text : 'sseat'
            });

            
        };

        window.renderCaptcha = renderCaptcha;

        $.getScript('https://www.google.com/recaptcha/api.js?onload=renderCaptcha&render=explicit', function() { });
    },
    btnSubmitClick: function (event) {
        var self = this;
        this.hideErrors();

        if (this.setModel()) {

            var callback = function (ret) {
                if (ret == true) {
                    self.loadCaptcha();
                    self.ui.contact_p_verifyOK.show();
                    self.ui.contact_btnSubmit.css('display', 'none');
                } else  {
                    self.showErrors(self.model.errors);
                    $('html,body').scrollTop(0);
                } 
            }
            this.model.validateNoBackbone(this.model.attributes, this.app, callback);
        }
    },
    setModel: function (parsedGeocodeResult) {
        this.hideErrors();
        this.model.set({
            Name: this.ui.contact_inputName.val(),
            EmailFrom: this.ui.contact_inputEmailFrom.val(),
            EmailTo: resources.X100689,
            Phone: this.ui.contact_inputPhone.val(),
            Subject: this.ui.contact_inputSubject.val(),
            Body: this.ui.contact_textareaBody.val(),
            Text01: resources.X100681,
            Text02: resources.X100682
        });

        //this.model.set({
        //    Name: 'steen',
        //    EmailFrom: 'steenhansenden@gmail.com',
        //    EmailTo: 'steenhansenden@yahoo.com',
        //    Phone: '12',
        //    Subject: '12',
        //    Body: '12',
        //    Text01: resources.X100681,
        //    Text02: resources.X100682
        //});

        return true;
    },
    save: function () {
        var self = this;
        this.hideErrors();

        var callback = function (ret) {
            if (ret == true) {
                var dialogWaitingModel = new Entities_Empty.Model();
                dialogWaitingModel.attributes.Title = resources.X100667;
                dialogWaitingModel.attributes.Text = resources.X100668;
                dialogWaitingModel.attributes.Button = resources.X100279;

                var dialogWaiting = new View_DialogWaiting({ model: dialogWaitingModel, parent: self });
                var callback = function (options) {
                    self.stopListening(dialogWaiting, "dialog:okclicked", callback);
                }
                self.listenTo(dialogWaiting, "dialog:okclicked", callback);
                self.app.dialogRegion.show(dialogWaiting);

        
                self.model.save(self.model.attributes, {
                    success: function () {
                        dialogWaiting.triggerMethod('dialog:close');

                        //this.model.attributes.Name = '';
                        //this.model.attributes.EmailFrom = '';
                        //this.model.attributes.Phone = '';
                        //this.model.attributes.Subject = '';
                        //this.model.attributes.Body = '';

                        var dialogBoxModel = new Entities_Empty.Model();
                        dialogBoxModel.attributes.Title = resources.X100662;
                        dialogBoxModel.attributes.Text = resources.X100906;
                        dialogBoxModel.attributes.Button = resources.X100279;

                        var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: self });
                        var callback01 = function (options) {
                            this.stopListening(dialogBox, "dialog:okclicked", callback01);

                            self.model.trigger('change');
                        }
                        self.listenTo(dialogBox, "dialog:okclicked", callback01);
                        self.app.regions.dialog.show(dialogBox);
                    },
                    error: function () {
                        dialogWaiting.triggerMethod('dialog:close');

                        var dialogBoxModel = new Entities_Empty.Model();
                        dialogBoxModel.attributes.Title = resources.X100662;
                        dialogBoxModel.attributes.Text = resources.X100684;
                        dialogBoxModel.attributes.Button = resources.X100279;

                        var dialogBox = new View_DialogBox({ model: dialogBoxModel, parent: self });
                        var callback02 = function (options) {
                            this.stopListening(dialogBox, "dialog:okclicked", callback02);
                        }
                        self.listenTo(dialogBox, "dialog:okclicked", callback02);
                        self.app.regions.dialog.show(dialogBox);
                    }
                });
            } else  {
                self.showErrors(self.model.errors);
                $('html,body').scrollTop(0);
            } 
        }

        this.model.validateNoBackbone(this.model.attributes, this.app, callback);
    }
}, Backbone.Radio.Requests);
